var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLivesBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:red;}.c{fill:#707070;}.d{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b36fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 -1594.895)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60,
    height: 60,
    transform: "translate(291 1594.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V59H59V1H1M0,0H60V60H0Z",
    transform: "translate(291 1594.895)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.444,0A6.45,6.45,0,0,0,0,6.444V45.105a6.45,6.45,0,0,0,6.444,6.444H32.218a6.45,6.45,0,0,0,6.444-6.444v-29H25.774a3.218,3.218,0,0,1-3.222-3.222V0ZM25.774,0V12.887H38.662ZM6.444,29a3.218,3.218,0,0,1,3.222-3.222h9.665A3.218,3.218,0,0,1,22.553,29v9.665a3.218,3.218,0,0,1-3.222,3.222H9.665a3.218,3.218,0,0,1-3.222-3.222ZM30.3,40.061l-4.521-3.01V30.607L30.3,27.6a1.275,1.275,0,0,1,.685-.211,1.237,1.237,0,0,1,1.238,1.238v10.41a1.237,1.237,0,0,1-1.238,1.238A1.2,1.2,0,0,1,30.3,40.061Z",
    transform: "translate(301.5 1599.12)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLivesBank);
export default __webpack_public_path__ + "static/media/iconLivesBank.d17d835f9b226a0b3ba09e9d4ab20d7a.svg";
export { ForwardRef as ReactComponent };